import { Patient } from "@models/patient";

export type PatientStatusKey = "active" | "inactive" | "archived";

export const getPatientDisplayName = (patient: Patient): string => {
  const fullName = `${patient.firstName || ""} ${patient.lastName || ""}`.trim();
  return fullName || patient.nickname || "";
};

export const getPatientStatusKey = (patient: Patient): PatientStatusKey => {
  if (patient.archivedAt) {
    return "archived";
  }
  if (!patient.isActive) {
    return "inactive";
  }
  return "active";
};
